export const MONTH_INITIALS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const SEASON_INITIALS = ["SP", "SU", "FA", "HO"];
export const SEASON = ["SPRING", "SUMMER", "FALL", "HOLIDAY"];

export const formatUSDate = (usDate: string): string => {
  const parts = usDate.split("-");
  const date = new Date(
    parseInt(parts[0]),
    parseInt(parts[1]) - 1,
    parseInt(parts[2]),
  );
  const options: any = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  return date.toLocaleDateString("en-US", options);
};

export const formatUSDateTime = (date: Date): string => {
  const options: any = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  };
  return date.toLocaleDateString("en-US", options);
};

export const getISOSubmitDateString = (date: Date) => {
  //submitDate AKA shipmentMonthDate is always the first of month returned
  const year = date.getFullYear();
  const month = date.getMonth();
  return getISODateWithoutTime(month, year);
}

export const getISODateWithoutTime = (month: number, year: number, day = 1) => {
  const date = new Date(year, month, day);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
};

export const calcPreviousMonthsISO = (start: Date, numMonthsBack: number) => {
  //includes current start month too as first element
  return Array(numMonthsBack)
      .fill(0)
      .map((_, i) => {
        const month = (start.getMonth() - i + 12) % 12;
        const year =
            start.getMonth() - i < 0
                ? start.getFullYear() - 1
                : start.getFullYear();
        return getISODateWithoutTime(month, year);
      });
}

export const formatToMonthNameYear = (isoDateOnly: string) => {
  const parts = isoDateOnly.split("-")
  const year = parts[0];
  const month = parseFloat(parts[1]);
  return `${MONTH_INITIALS[month - 1]} ${year}`;
}